import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g>
      <path
        d="M1.81,15.19 C-1.06097001,11.3611924 -0.407647131,5.95056758 3.29216293,2.91516947 C6.99197299,-0.12022865 12.4259626,0.296243378 15.62,3.86 L16,4.28 L16.38,3.86 C19.4684574,0.391201871 24.6987073,-0.13491733 28.4161619,2.64926323 C32.1336165,5.43344379 33.0999734,10.6005 30.64,14.54 L28.94,13.47 C30.8244453,10.412537 30.0648283,6.42242711 27.1887868,4.27124157 C24.3127453,2.12005603 20.2705711,2.51858233 17.87,5.19 L16,7.29 L14.13,5.19 C11.6674229,2.34148703 7.38261542,1.97634091 4.47355482,4.3670894 C1.56449422,6.7578379 1.09256821,11.0322025 3.41,14 L1.81,15.19 Z"/>
      <polygon points="16 31.18 8.26 22.67 9.74 21.33 16 28.21 22.26 21.33 23.74 22.67"/>
      <polygon className="euiIcon__fillSecondary" points="16.16 23.29 12.06 16.12 10.62 19 0 19 0 17 9.38 17 11.94 11.88 15.84 18.71 19.97 8.39 23.66 17 32 17 32 19 22.34 19 20.03 13.61"/>
    </g>
  </svg>
)
